import styled from 'styled-components'

import { PreviewCard } from './PreviewCard'
import { PreviewCategoryCard } from './PreviewCategoryCard'
import type { FileType } from './types'

const Container = styled.div`
  display: flex;
  flex-direction: column;
`
type Category = {
  value: string
  display: string
}

type PreviewDisplayProps = {
  files: Record<string, FileType[]>
  hideCategories: string[]
  categories: Category[]
  handleDelete(fileName: string): void
  handleDisplay(fileName: string): void
  handleClose(): void
  toggleCategory(category: string): void
}

const PreviewDisplay = (props: PreviewDisplayProps) => {
  const {
    files,
    hideCategories,
    categories,
    handleDelete,
    handleDisplay,
    handleClose,
    toggleCategory
  } = props
  return (
    <Container>
      {categories.map(category => {
        if (files[category.value]) {
          return (
            <div key={category.value}>
              <PreviewCategoryCard
                title={`${category.display} (${files[category.value].length})`}
                category={category.value}
                toggleCategory={toggleCategory}
                hideContents={hideCategories.includes(category.value)}
              />
              {!hideCategories.includes(category.value)
                && files[category.value].map((file: FileType, index: number) =>
                  <PreviewCard
                    key={index}
                    id={file.id}
                    src={file.src}
                    mimeType={file.mimeType}
                    title={file.file.name}
                    size={file.file.size}
                    handleDelete={handleDelete}
                    handleDisplay={handleDisplay}
                    handleClose={handleClose}
                    progress={Math.round((Number(file.progress ?? 0)) * 100)}
                    timeLeft={file.timeLeft}
                    error={file.error}
                    displayInModal={file.showInModal || false}
                  />
                )
              }
            </div>
          )
        }
        return null
      })}

    </Container>
  )
}

export { PreviewDisplay }
